var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23077 16C1.23077 7.84287 7.84287 1.23077 16 1.23077C24.1571 1.23077 30.7692 7.84287 30.7692 16C30.7692 19.8926 29.2644 23.4326 26.8029 26.0706C26.3173 24.4151 25.0481 22.7901 23.4872 21.5097C22.1699 20.4312 20.5785 19.5402 18.9214 19.0498C20.6939 18.0882 21.899 16.2101 21.899 14.0496C21.899 10.9118 19.3541 8.36673 16.2161 8.36673C13.0783 8.36673 10.5333 10.9116 10.5333 14.0496C10.5333 16.2066 11.7352 18.0832 13.506 19.0465C11.8265 19.5353 10.1967 20.4263 8.84427 21.5049C7.184 22.8286 5.82823 24.5289 5.36829 26.2532C2.80578 23.5961 1.23077 19.9824 1.23077 16ZM6.43897 27.2578C9.01588 29.4469 12.3541 30.7691 16 30.7691C19.742 30.7691 23.1586 29.378 25.7612 27.0848C25.5817 25.5992 24.4423 23.8844 22.7067 22.4612C20.8334 20.9259 18.42 19.865 16.2165 19.865C14.0114 19.865 11.5416 20.9275 9.61218 22.466C7.75323 23.95 6.55118 25.7433 6.43897 27.2578ZM16 0C7.16349 0 0 7.16349 0 16C0 24.8365 7.16349 32 16 32C24.8365 32 32 24.8365 32 16C32 7.16349 24.8365 0 16 0ZM16.2163 9.59795C13.758 9.59795 11.7642 11.5915 11.7642 14.0501C11.7642 16.51 13.7578 18.5022 16.2163 18.5022C18.6747 18.5022 20.6684 16.5102 20.6684 14.0501C20.6684 11.5917 18.6748 9.59795 16.2163 9.59795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconOne);
export default __webpack_public_path__ + "static/media/user_icon_one.a0a520c8922764652b0dfab617ec136f.svg";
export { ForwardRef as ReactComponent };